// packages/frontend/src/utils/autoAuth.ts

import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../services/firebase';
import { useLogger } from './logger';

const logger = useLogger('AutoAuth');

// Auto-authentication for development
export async function autoAuthenticate(): Promise<boolean> {
  try {
    // Check if user is already authenticated
    if (auth.currentUser) {
      logger.info('User already authenticated', {
        uid: auth.currentUser.uid,
        email: auth.currentUser.email,
      });
      return true;
    }

    // For development, try to auto-login with the real user credentials
    if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS !== "false") {
      const email = 'aviv.laufer@gmail.com';
      const password = 'password123'; // This should match what was used when creating the user
      
      logger.info('Attempting auto-authentication for development', { email });
      
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        logger.info('Auto-authentication successful', {
          uid: userCredential.user.uid,
          email: userCredential.user.email,
        });
        
        // The auth store will be initialized by the App component
        // and will detect the Firebase user automatically
        return true;
      } catch (error) {
        logger.warn('Auto-authentication failed, user will need to login manually', {
          error: error instanceof Error ? error.message : 'Unknown error',
        });
        return false;
      }
    }

    return false;
  } catch (error) {
    logger.error('Auto-authentication error', {
      error: error instanceof Error ? error.message : 'Unknown error',
    });
    return false;
  }
}

// Initialize auto-authentication when the module is imported
if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS !== "false") {
  // Wait a bit for Firebase to initialize, then try auto-auth
  setTimeout(() => {
    autoAuthenticate();
  }, 1000);
}
